import { EventBroker } from '../../../lib/utils/event-broker';

export const EVENTS = {
  INIT: 'INIT',
  CLOSE: 'CLOSE',
  SAVE: 'SAVE',
};

export const addToDesignGalleryEventBroker = new EventBroker();

